export enum UserType {
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT'
}
